import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ModalController, Platform } from '@ionic/angular';
import { CloseOverlayService } from '../../_services/closeOverlay.service';

@Component({
  selector: 'app-user-permissions',
  templateUrl: './user-permissions.page.html',
  styleUrls: ['./user-permissions.page.scss'],
})
export class UserPermissionsPage implements OnInit {
  subscription: any;

  constructor(
    private modalController: ModalController,
    private platform: Platform,
    private location: Location,
    private closeOverlayService: CloseOverlayService
  ) {}

  closeModal() {
    this.modalController.dismiss();
  }

  ionViewDidEnter() {
    this.subscription = this.platform.backButton.subscribeWithPriority(
      99999,
      () => {
        if (this.constructor.name === 'UserPermissionsPage') {
          this.closeOverlayService.trigger();
        } else {
          this.location.back();
        }
      }
    );
  }

  ionViewDidLeave() {
    this.subscription.unsubscribe();
  }

  ngOnInit() {}
}
